import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, setDoc, deleteDoc, collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { FaUserPlus, FaUserCheck } from "react-icons/fa";
import { Toast } from "../components_root/ToastContext";
export default function FollowButton({ companyuid }) {
  const [user, setUser] = useState(null);
  const [isFollowing, setIsFollowing] = useState(false);
  const [followerCount, setFollowerCount] = useState(0);
  const [loading, setLoading] = useState(true);
    const { Toastshow } = Toast();
  // Watch login status
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      if (currentUser && companyuid) {
        const followRef = doc(db, "followers", companyuid, "items", currentUser.uid);
        const followSnap = await getDoc(followRef);
        setIsFollowing(followSnap.exists());
      } else {
        setIsFollowing(false);
      }
    });

    return () => unsubscribe();
  }, [companyuid]);

  // Real-time follower count (everyone can see)
  useEffect(() => {
    if (!companyuid) return;

    const itemsRef = collection(db, "followers", companyuid, "items");
    const unsubscribe = onSnapshot(itemsRef, (snapshot) => {
      setFollowerCount(snapshot.size);
    });

    return () => unsubscribe();
  }, [companyuid]);

  // Toggle follow/unfollow (only for logged-in users)
  const toggleFollow = async () => {
    if (!user) {
        
     Toastshow("Please log in to follow this company.");
      return;
    }

    const followRef = doc(db, "followers", companyuid, "items", user.uid);

    try {
      if (isFollowing) {
        await deleteDoc(followRef);
        setIsFollowing(false);
      } else {
        await setDoc(followRef, { userId: user.uid, followedAt: new Date().toISOString() });
        setIsFollowing(true);
      }
    } catch (err) {
      console.error("Error updating follow status:", err);
    }
  };

  if (loading) return null;

  return (
    <div
      onClick={toggleFollow}
      title={isFollowing ? "Unfollow" : "Follow"}
      className={`button-ui2 fill text-h2 p-2 rounded cursor flex items-center ${
        isFollowing ? "green" : ""
      }`}
    >
      {isFollowing ? (
        <>
          <FaUserCheck className="icon" /> Following
        </>
      ) : (
        <>
          <FaUserPlus className="icon" /> Follow
        </>
      )}
   {followerCount > 0 && ( <span className="text-h2 ml-2">{followerCount}</span> )}
    </div>
  );
}
